import { render, staticRenderFns } from "./ShowRecommendList.vue?vue&type=template&id=25b80a68&scoped=true"
import script from "./ShowRecommendList.vue?vue&type=script&lang=js"
export * from "./ShowRecommendList.vue?vue&type=script&lang=js"
import style0 from "./ShowRecommendList.vue?vue&type=style&index=0&id=25b80a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b80a68",
  null
  
)

export default component.exports